export default [
    {
        path: 'relatorio-quantitativo',
        component: () => import(
            /* webpackChunkName: 'transporte-paciente-relatorio-quantitativo' */
            '@/views/transporte-paciente/relatorio-quantitativo/Index'
        ),
        redirect: 'relatorio-quantitativo/index',
        children: [
            {
                name: 'transporte-paciente-relatorio-quantitativo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'transporte-paciente-relatorio-quantitativo' */
                    '@/views/transporte-paciente/relatorio-quantitativo/List.vue'
                ),
            },
        ],
    },
]
